import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth, RequireRole } from "./components/layout/AppLayout";
import { ToastProvider } from "./components/ui/Toast";
import { AlertRulesPage } from "./pages/AlertRulesPage";
import { AlertsPage } from "./pages/AlertsPage";
import { DashboardPage } from "./pages/DashboardPage";
import { DeviceDetailPage } from "./pages/DeviceDetailPage";
import { DevicesPage } from "./pages/DevicesPage";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PatchesPage } from "./pages/PatchesPage";
import { SnmpTargetsPage } from "./pages/SnmpTargetsPage";
import { UsersPage } from "./pages/UsersPage";
import { EnrollmentPage } from "./pages/EnrollmentPage";
import { InstallPage } from "./pages/InstallPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route element={<RequireAuth />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/devices" element={<DevicesPage />} />
                <Route path="/devices/:id" element={<DeviceDetailPage />} />
                <Route path="/patches" element={<PatchesPage />} />
                <Route path="/alerts" element={<AlertsPage />} />
                <Route path="/alert-rules" element={<AlertRulesPage />} />
                <Route path="/snmp" element={<SnmpTargetsPage />} />
                <Route
                  path="/users"
                  element={
                    <RequireRole roles={["admin"]}>
                      <UsersPage />
                    </RequireRole>
                  }
                />
                <Route
                  path="/settings/enrollment"
                  element={
                    <RequireRole roles={["admin"]}>
                      <EnrollmentPage />
                    </RequireRole>
                  }
                />
                <Route path="/settings/install" element={<InstallPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  );
}